import React from "react";
import Footer from "../Home/footer/Footer";
import Middlebar from "../Home/middleBar/Middlebar";
import Topheader from "../Home/topHeader/Topheader";
import NavMenu from "../Home/navigationBar/NavMenu";

const Lms = () => {
  return (
    <div>
      <Topheader />
      <Middlebar />
      <NavMenu />
      Lms
      <Footer />
    </div>
  );
};

export default Lms;
